import { isReservedSetName } from 'src/components/SetsConfigDetails/newnessSet';

type SetDefinition = Models.SetsPlayground.SetDefinition;

export const VISTAPRINT_SITES: Record<string, string> = {
    'da-dk': 'https://www.vistaprint.dk',
    'de-at': 'https://www.vistaprint.at',
    'de-ch': 'https://www.vistaprint.ch',
    'de-de': 'https://www.vistaprint.de',
    'en-au': 'https://www.vistaprint.com.au',
    'en-ca': 'https://www.vistaprint.ca',
    'fr-ca': 'https://www.vistaprint.ca/fr',
    'en-gb': 'https://www.vistaprint.co.uk',
    'en-ie': 'https://www.vistaprint.ie',
    'en-in': 'https://www.vistaprint.in',
    'en-nz': 'https://www.vistaprint.co.nz',
    'en-sg': 'https://www.vistaprint.sg',
    'en-us': 'https://www.vistaprint.com',
    'es-us': 'https://www.vistaprint.com/es',
    'es-es': 'https://www.vistaprint.es',
    'fi-fi': 'https://www.vistaprint.fi',
    'fr-be': 'https://www.vistaprint.be/fr',
    'fr-ch': 'https://www.vistaprint.ch/fr',
    'fr-fr': 'https://www.vistaprint.fr',
    'it-ch': 'https://www.vistaprint.ch/it',
    'it-it': 'https://www.vistaprint.it',
    'nb-no': 'https://www.vistaprint.no',
    'nl-be': 'https://www.vistaprint.be',
    'nl-nl': 'https://www.vistaprint.nl',
    'pt-pt': 'https://www.vistaprint.pt',
    'sv-se': 'https://www.vistaprint.se',
};

/**
 * Builds a gallery URL using the new format: {localized_site_prefix}/gallery/g/{gallery-name}
 * @param locale - The locale/culture code (e.g., 'en-us', 'fr-fr')
 * @param productKey - The product key
 * @param productVersion - The product version
 * @param forcedRankingStrategyOverride - Optional forced ranking strategy override
 * @param sets - Optional array of set definitions to include as rawSets
 * @returns The constructed gallery URL
 */
export const buildGalleryUrl = (
    locale: string,
    productKey: string,
    productVersion: string | null | undefined,
    forcedRankingStrategyOverride?: string,
    sets?: SetDefinition[],
): string => {
    const params = new URLSearchParams();

    params.set('noCache', 'true');
    params.set('debug', 'true');
    params.set('bypassApproval', 'true');

    if (forcedRankingStrategyOverride) {
        params.set('forcedRankingStrategyOverride', forcedRankingStrategyOverride);
    }

    if (sets && sets.length > 0) {
        sets.forEach((set) => {
            if (isReservedSetName(set.name)) {
                params.append('rawSets', JSON.stringify(set));

                return;
            }

            // Ensure filters structure is always present even if empty
            const setWithFilters = {
                ...set,
                filters: {
                    product: set.filters?.product || { productOptions: {} },
                    category: set.filters?.category || [],
                    content: set.filters?.content || {},
                },
            };

            params.append('rawSets', JSON.stringify(setWithFilters));
        });
        params.set('showSets', 'true');
    }

    const siteUrl = VISTAPRINT_SITES[locale] || VISTAPRINT_SITES['en-us'];
    const versionPart = productVersion ? `__${productVersion}` : '';
    const galleryName = `dynamic__${productKey}${versionPart}`;

    return `${siteUrl}/gallery/g/${galleryName}?${params.toString()}`;
};
